function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Playlistsff");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Sidebar/-1820",
  transform: "translate(-49.000000, -414.000000)"
}, React.createElement("g", {
  id: "nav",
  transform: "translate(4.000000, 0.000000)"
}, React.createElement("g", {
  id: "Library",
  transform: "translate(20.000000, 364.000000)"
}, React.createElement("g", {
  id: "Playlists",
  transform: "translate(0.000000, 38.000000)"
}, React.createElement("g", {
  id: "Icons/Playlists",
  transform: "translate(24.000000, 11.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("path", {
  d: "M3.25,5 C2.28350169,5 1.5,4.21649831 1.5,3.25 C1.5,2.28350169 2.28350169,1.5 3.25,1.5 C4.21649831,1.5 5,2.28350169 5,3.25 C5,4.21649831 4.21649831,5 3.25,5 Z M3.25,14.5 C2.28350169,14.5 1.5,13.7164983 1.5,12.75 C1.5,11.7835017 2.28350169,11 3.25,11 C4.21649831,11 5,11.7835017 5,12.75 C5,13.7164983 4.21649831,14.5 3.25,14.5 Z M12.75,5 C11.7835017,5 11,4.21649831 11,3.25 C11,2.28350169 11.7835017,1.5 12.75,1.5 C13.7164983,1.5 14.5,2.28350169 14.5,3.25 C14.5,4.21649831 13.7164983,5 12.75,5 Z M12.75,14.5 C11.7835017,14.5 11,13.7164983 11,12.75 C11,11.7835017 11.7835017,11 12.75,11 C13.7164983,11 14.5,11.7835017 14.5,12.75 C14.5,13.7164983 13.7164983,14.5 12.75,14.5 Z",
  id: "Combined-Shape",
  fill: "#1E1F20",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
})))))));

var SvgPlaylists = function SvgPlaylists(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaylists, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playlists.146e1ba8.svg";
export { ForwardRef as ReactComponent };